import React, { Component, Fragment } from 'react'
import './index.css'
import "../../AlgorithmToolsSharing/index.css"
import { Button, Modal } from 'antd';
import FileViewer from 'react-file-viewer'
import PDFViewer from 'react-pdf-js'
import ToolImg from '../../static/ToolImg.png'
export default class PreviewFileComponent extends Component {

  state = {
    currentPDFPageNum: 1,//PDF预览时当前页面数
    totalPDFPages: 0,//PDF总页数
  }

  onDocumentComplete = (pages) => {
    this.setState({
      currentPDFPageNum: 1,
      totalPDFPages:pages
    })
  }

  handlePrivious = () => {
    this.setState({
      currentPDFPageNum: this.state.currentPDFPageNum - 1
    })
  }

  handleNext = () => {
    this.setState({
      currentPDFPageNum: this.state.currentPDFPageNum + 1
    })
  }

  colosePreviewModal = () => {
    this.props.colosePreviewModal()
  }

  render() {
    const { isPreviewModalshown, currentPreviewItem, filePreviewPath } = this.props
    const {currentPDFPageNum,totalPDFPages} = this.state
    return (
      <div>
        <Modal
          className="preview-file-modal"
          visible={isPreviewModalshown}
          footer={null}
          title={"预览"}
          destroyOnClose={true}
          onCancel={() => this.colosePreviewModal()}
        >
          {
            currentPreviewItem ?
            <Fragment>
              <div className='Filedownload_Modal_Title'>
                {/* <div className='Filedownload_Modal_TitleText'>{currentPreviewItem.chsname}</div> */}
                <div className="algorithmToolsSharing-detail-modal-top-area">
                  <img src={ToolImg} className="algorithmToolsSharing-detail-modal-img"></img>
                  <div className="algorithmToolsSharing-detail-modal-top-right-area">
                    <div className="algorithmToolsSharing-detail-modal-tool-chsName-wrap">
                      <div className="algorithmToolsSharing-detail-modal-tool-chsName-title">产品名称:</div>
                      <div className="algorithmToolsSharing-detail-modal-tool-chsName-vaiue" style={{maxWidth:'200px'}}>{currentPreviewItem.chsname}</div>
                    </div>
                    <div className="algorithmToolsSharing-detail-modal-tool-algorithmname-wrap">
                      <div className="algorithmToolsSharing-detail-modal-tool-algorithmname-title">产品类型:</div>
                      <div className="algorithmToolsSharing-detail-modal-tool-algorithmname-vaiue">{currentPreviewItem.producetype}</div>
                    </div>
                    <div className="algorithmToolsSharing-detail-modal-tool-version-wrap">
                      <div className="algorithmToolsSharing-detail-modal-tool-version-title"> 版本:</div>
                      <div className="algorithmToolsSharing-detail-modal-tool-version-vaiue">{currentPreviewItem.version}</div>
                    </div>
                    <div className="algorithmToolsSharing-detail-modal-tool-author-wrap">
                      <div className="algorithmToolsSharing-detail-modal-tool-author-title">交互类型:</div>
                      <div className="algorithmToolsSharing-detail-modal-tool-author-vaiue">{currentPreviewItem.artificial}</div>
                    </div>
                    <div className="algorithmToolsSharing-detail-modal-tool-dllname-wrap">
                      <div className="algorithmToolsSharing-detail-modal-tool-dllname-title">卫星:</div>
                      <div className="algorithmToolsSharing-detail-modal-tool-dllname-vaiue">{currentPreviewItem.satellite}</div>
                    </div>
                    <div className="algorithmToolsSharing-detail-modal-tool-dllname-wrap">
                      <div className="algorithmToolsSharing-detail-modal-tool-dllname-title">传感器:</div>
                      <div className="algorithmToolsSharing-detail-modal-tool-dllname-vaiue">{currentPreviewItem.sensor}</div>
                    </div>
                  </div>
                </div>
              </div>
              {
                filePreviewPath === '' ?
                  <div className="preview-file-modal_Empty">暂无内容</div> :
                  filePreviewPath.split('.')[4] === 'pdf' ?
                    <>
                      <div className="preview-file-modal-content">
                        <PDFViewer
                          fileType={filePreviewPath.split('.')[4]}
                          onDocumentComplete={(pages)=>this.onDocumentComplete(pages)}
                          page={currentPDFPageNum}
                          file={filePreviewPath}
                        ></PDFViewer>
                      </div>
                      <div className="preview-file-modal-footer">
                        {
                            currentPDFPageNum === 1 ? null :
                              <Button
                                type="primary"
                                className="left-change-page"
                                onClick={() => this.handlePrivious()}
                              >上一页</Button>
                          }
                        <div className="pdfViewer-footer-changPage">
                          <span>第{currentPDFPageNum}页</span>/<span>共{totalPDFPages}页</span>
                        </div>
                          {
                            currentPDFPageNum === totalPDFPages ? null :
                              <Button
                                type="primary"
                                className="right-change-page"
                                onClick={() => this.handleNext()}
                              >下一页</Button>
                          }
                      </div>
                    </> :
                    <div className="fileViewer-content">
                      <FileViewer
                        fileType={filePreviewPath.split('.')[4]}
                        filePath={filePreviewPath}
                      // filePath='http://10.0.121.14:8084/tiles/综合数据库/文档数据/KJ 10001-2022新闻信息.docx'
                      >
                      </FileViewer>
                    </div>
              }
            </Fragment>
            : <div className="Filedownload_Modal_Empty">暂无内容</div>}
        </Modal>
      </div>
    )
  }
}
